import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { DashNotificationsService } from 'app/services/dash-notifications.service';
import { environment } from 'environments/environment';
import { fromEvent, merge } from 'rxjs';

@Component({
  selector: 'share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {
  @Input('url')
  get url(): string { return this._url; }
  set url(url: string) {
    this._url = environment.appRoot  + url;
  }
  private _url: string = '';
  // @Input('url') url: string;
  @Output() onShare : EventEmitter<null> = new EventEmitter();
  @ViewChildren('button', { read: ElementRef }) buttonRefs: QueryList<ElementRef<HTMLElement>>;

  constructor(private notifications: DashNotificationsService) {}

  ngOnInit(){
  }

  ngAfterViewInit() {
    merge(
      ...this.buttonRefs.map(el => fromEvent(el.nativeElement, 'click'))
    ).subscribe(() => {
      this.onShare.emit();
    })
  }

  showCopyAlert(){
    this.notifications.success('Link Copied!');
  }
}
